export default "__VITE_ASSET__IX0yht5H__"